const CustomYAxisTick = ({ x, y, payload, maxChars = 18 }) => {
  const raw = payload.value ?? "";
  const truncated =
    raw.length > maxChars ? raw.slice(0, maxChars).trimEnd() + "…" : raw;

  const lines = truncated.split("\n");
  const lineHeight = 15;
  const totalHeight = lineHeight * lines.length;

  return (
    <g transform={`translate(${x},${y})`}>
      {lines.map((line, i) => (
        <text
          key={i}
          x={-8}
          y={-(totalHeight / 10) + i * lineHeight + lineHeight / 2}
          textAnchor="end"
          dominantBaseline="middle"
          fill="#535862"
          fontSize={10}
          fontFamily="Inter, system-ui, sans-serif"
        >
          {line}
        </text>
      ))}
    </g>
  );
};

export default CustomYAxisTick;
